import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Kpi } from "@/components/VulnerabilityWatch/Info.tsx";
import type { PortalOverview } from "@/types";
import { knownOverview, windowCves } from "@/utils/portalOverview.ts";
import { sourcesHref } from "@/utils/sourcesFilters.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";
import type { Detection } from "@/utils/vulnerabilityCopy.ts";

export function AtYourPortalBlock({ cve, detection, overview }: {
  readonly cve: string;
  readonly detection: Detection;
  readonly overview: PortalOverview | undefined;
}) {
  const known = knownOverview(overview);
  const cves = windowCves(known);
  const seen = cves?.get(cve);
  return (
    <Box>
      <Kpi label={copy.AT_PORTAL_TITLE} tip={copy.TIP_AT_PORTAL} value={copy.atPortalLabel(detection, cves !== null, seen)} />
      {known && (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
          {copy.lastDaysLabel(known.coverage.window_days)}
        </Typography>
      )}
      {seen && <Link component={RouterLink} to={sourcesHref({ search: cve })} variant="caption">{copy.OPEN_IN_SOURCES}</Link>}
    </Box>
  );
}
